<div class="ui active inverted dimmer" *ngIf="isLoading; else showDefault">
    <div class="ui text loader">Loading...</div>
</div>
<ng-template #showDefault>
    <calendarhero-wizard
        [wizardTask]="wizardTask"
        [wizardConfig]="wizardConfig"
        [wizardMetaData]="wizardMetaData"
        [meeting]="meeting"
        [meetingTypes]="meetingTypes"
        [wizardUser]="wizardUser"
        (onHandleTrackEvent)="handleTrackEvent($event)"
    ></calendarhero-wizard>
</ng-template>
